import { render, staticRenderFns } from "./RehberVideoButton.vue?vue&type=template&id=eb7d45f2&scoped=true"
import script from "./RehberVideoButton.vue?vue&type=script&lang=ts"
export * from "./RehberVideoButton.vue?vue&type=script&lang=ts"
import style0 from "./RehberVideoButton.vue?vue&type=style&index=0&id=eb7d45f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb7d45f2",
  null
  
)

export default component.exports